import { Component, Input } from '@angular/core';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { OrderSummaryChartService } from './order-summary-chart.service';
import { getBars } from './order-summary-chart.calculations';
import { amountFormat } from '../../../gameday/gameday.constants';
import { SummaryBar } from './order-summary-bar-chart.component';
import { GameDayModel } from '../../../models/gameday-model';

@Component({
  selector: 'muni-gameday-order-summary-chart',
  viewProviders: [OrderSummaryChartService],
  templateUrl: './order-summary-chart.template.html',
  styleUrls: ['./order-summary-chart.styles.scss']
})
export class OrderSummaryChartComponent {
  @Input()
  public set highlightMaturityId(id: string) {
    this.highlightMaturityIdSink.next(id);
  }

  @ReusableStreamProperty
  public readonly orders: Observable<
    string
  > = this.orderSummaryChartService.data.pipe(
    map(({ orders }) => amountFormat.format(orders.length)),
    distinctUntilChanged()
  );

  @ReusableStreamProperty
  public readonly total: Observable<
    string
  > = this.orderSummaryChartService.data.pipe(
    map(({ orders }) =>
      amountFormat.format(
        orders.reduce(
          (prev, order: GameDayModel.Order) => prev + order.amount,
          0
        ) / 1000
      )
    ),
    distinctUntilChanged()
  );

  public highlightMaturityIdSink = new BehaviorSubject<string>(undefined);

  @ReusableStreamProperty
  public readonly bars: Observable<SummaryBar[]> = combineLatest(
    this.orderSummaryChartService.segments,
    this.highlightMaturityIdSink
  ).pipe(
    map(([segments, highlightMatyrityId]) =>
      getBars(segments, highlightMatyrityId)
    )
  );

  constructor(private orderSummaryChartService: OrderSummaryChartService) {}
}
